import { useAuthModal } from "../../contexts/AuthModalContext";

export type SignUpCardProps = {
  testId: string;
  class?: string;
};

/**
 * The invitation that ends a public page. The first site embedded its whole sign-in form here; this opens
 * the sign-in modal instead, which is the same form one tap away.
 */
export const SignUpCard = ({ testId, class: className = "" }: SignUpCardProps) => {
  const { showAuthModal } = useAuthModal();

  return (
    <div class={`w-full px-4 py-6 bg-white dark:bg-neutral-800 rounded-lg border border-gray-200 dark:border-gray-700 text-center ${className}`}>
      <h3 class="text-xl font-bold text-gray-900 dark:text-gray-100 mb-2">Sign up for free</h3>
      <p class="text-sm text-gray-600 dark:text-gray-300 mb-4">Create an account to follow authors, bookmark articles and more</p>
      <button
        type="button"
        onClick={() => showAuthModal("Sign up for free", "Create an account to follow authors, bookmark articles and more")}
        class="w-full px-6 py-3 bg-gradient-to-r from-blue-600 to-purple-600 text-white font-semibold rounded-lg hover:from-blue-700 hover:to-purple-700 transition-all shadow-lg text-center"
        data-test-click={testId}
      >
        Continue
      </button>
    </div>
  );
};
